import React from "react";
import { useSearchParams } from "react-router-dom";

import { setHideNavBar } from "../../core/redux/authSlice";
import { useAppDispatch } from "../../core/redux/hooks";
import { PostApiMethod } from "../../core/services/apiService";
import { DtoKioskSettingsData } from "../../core/dto/dashboard.dto";
import { loggerHelper } from "../../core/services/sharedService";

import VideoRoom from "../DashboardComponents/VideoRoom";
import ZoomVideoRoom from "../DashboardComponents/ZoomVideoRoom";
import { checkAbilityToUseZOOM } from "../../core/services/sharedService";

const KioskVideoRoom = () => {
    const logger = React.useCallback((message: String, details: any) => { loggerHelper(message, details); }, []);
    const [searchParams] = useSearchParams();
    const roomId = searchParams.get("roomId");
    const roomSid = searchParams.get("roomSid");
    const twilioToken = searchParams.get("token");
    const locationId = searchParams.get("id");
    const kioskToken = searchParams.get("kioskToken");
    const tenantId = searchParams.get("tenantId");
    const agentId = searchParams.get("agentId");
    const dispatch = useAppDispatch();
    logger(`Kiosk videoRoom video searchParams-`, { "roomId": roomId, "roomSid": roomSid, "twilioToken": twilioToken, "locationId": locationId, "kioskToken": kioskToken, "tenantId": tenantId, "agentId": agentId });
    const [isValidKioskUser, setIsValidKioskUser] =
        React.useState<boolean>(false);
    const terminateVideoCallRef = React.useRef(null);
    const [kioskSettingsInfo, setKioskSettingsInfo] =
        React.useState<DtoKioskSettingsData>();
    const holdVideoCallRef = React.useRef<Function>(null);
    const validateKiosk = React.useCallback(() => {
        if (roomId && twilioToken && locationId && kioskToken && tenantId && agentId) {
            setIsValidKioskUser(true);
        } else {
            setIsValidKioskUser(false);
        }
    }, [roomId, twilioToken, locationId, kioskToken, tenantId, agentId]);

    React.useEffect(() => {
        dispatch(setHideNavBar(true));
        validateKiosk();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateKiosk]);

    React.useEffect(() => {
        getKioskLocationInfo();
        return () => {
            dispatch(setHideNavBar(false));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getKioskLocationInfo = React.useCallback(() => {
        const formData = {
            agent_id: agentId,
            kiosk: locationId,
        };
        logger(`Kiosk videoRoom video getKioskLocationInfo formData-`, formData);
        PostApiMethod("tenant/kiosk/display/kiosk-data", formData, {
            headers: {
                kiosk_token: "",
                access_token: kioskToken!,
                tenant: tenantId!,
            },
        })
            .then((res: any) => {
                if (res.data.status === "Success") {
                    logger(`Kiosk videoRoom video getKioskLocationInfo response-`, res.data);
                    if (res.data.data) {
                        setKioskSettingsInfo(res.data.data);
                    }
                }
            })
            .catch((err: any) => {
                console.log(err);
                logger(`Kiosk videoRoom video getKioskLocationInfo error-`, err);
            });
    }, [agentId, kioskToken, locationId, logger, tenantId]);

    return (
        <>
            <div
                className={`${checkAbilityToUseZOOM()}` ? "zoom-kiosk-view" : "row width-100 kioskVideoRoomRow"}
                style={{
                    backgroundColor:
                        kioskSettingsInfo && kioskSettingsInfo.background_color
                            ? kioskSettingsInfo.background_color
                            : "#ffffff",
                }}
            >
                <div className="col-12 kiosk-video-room-header">
                    {kioskSettingsInfo && kioskSettingsInfo.logo ? (
                        <div className="text-center d-flex align-items-center justify-content-center width-100">
                            <img src={kioskSettingsInfo.logo} alt="Company logo" />
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="col-12 pb-2 kioskVideoSection p-0">
                    {isValidKioskUser ? (
                        !checkAbilityToUseZOOM() ? (
                            <VideoRoom
                                terminateVideoCallRef={terminateVideoCallRef}
                                roomName={roomId!}
                                roomSid={roomSid!}
                                agentId={agentId!}
                                twilioToken={twilioToken!}
                                locationId={locationId!}
                                notificationId={""}
                                isKiosk={true}
                                setLocalParticipantInfo={() => { }}
                                terminateVideoCall={() => { }}
                                agentName={
                                    kioskSettingsInfo &&
                                        kioskSettingsInfo.display_name
                                        ? kioskSettingsInfo.display_name
                                        : ""
                                }
                                agentNameColor={
                                    kioskSettingsInfo &&
                                        kioskSettingsInfo.background_color
                                        ? kioskSettingsInfo.background_color
                                        : "#ffffff"
                                }
                                putCallOnHold={() => { }}
                                holdVideoCallRef={holdVideoCallRef}
                                inHoldDuration={undefined}
                                addParticipantVideoCall={() => { }}
                            />
                        ) : (
                            <ZoomVideoRoom
                                twilioToken={twilioToken!}
                                sessionName={roomId!}
                                userName={'kiosk_user'}
                                terminateVideoCallRef={terminateVideoCallRef}
                                terminateVideoCall={() => { }}
                                locationId={locationId!}
                                notificationId={""}
                                isKiosk={true}
                                setLocalParticipantInfo={() => { }}
                                agentName={
                                    kioskSettingsInfo &&
                                        kioskSettingsInfo.display_name
                                        ? kioskSettingsInfo.display_name
                                        : ""
                                }
                                agentNameColor={
                                    kioskSettingsInfo &&
                                        kioskSettingsInfo.background_color
                                        ? kioskSettingsInfo.background_color
                                        : "#ffffff"
                                }
                            />
                        )
                    ) : (
                        <div className="text-center app-Fixed-height d-flex align-items-center justify-content-center">
                            Something went wrong.
                        </div>
                    )}
                </div>

            </div>
            <div className="col-12 kiosk-video-room-footer p-0" style={{
                backgroundColor:
                    kioskSettingsInfo && kioskSettingsInfo.background_color
                        ? kioskSettingsInfo.background_color
                        : "#ffffff",
            }}>
                {kioskSettingsInfo && kioskSettingsInfo.footer_image !== undefined ? (
                    <div className="text-center d-flex align-items-center justify-content-center w-100">
                        <img alt={"kiosk"} src={kioskSettingsInfo.footer_image} />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </>
    );
};

export default KioskVideoRoom;
